import { IReportsState } from './reportsContext';
import { ReportsActionsTypes, TReportsAction } from '../reportsAction';

export const reportsReducer = (state: IReportsState, action: TReportsAction): IReportsState => {
	switch (action.type) {
		case ReportsActionsTypes.SET_HAS_BAN_ON_CHANGES:
			return {
				...state,
				hasBanOnChanges: action.payload.hasBanOnChanges,
			};
		case ReportsActionsTypes.SET_ALL_DATA:
			return {
				...state,
				restaurantId: action.payload.restaurantId,
				id: action.payload.id,
				IDReportType: action.payload.IDReportType,
				IDsScheduleTypes: action.payload.IDsScheduleTypes,
				emails: action.payload.emails,
				copyEmails: action.payload.copyEmails,
				sendingReportAfterShiftClosing: action.payload.sendingReportAfterShiftClosing,
			};
		case ReportsActionsTypes.SET_ID_REPORT_TYPE:
			return {
				...state,
				IDReportType: action.payload.IDReportType,
				sendingReportAfterShiftClosing: action.payload.sendingReportAfterShiftClosing,
				IDsScheduleTypes: action.payload.IDsScheduleTypes,
			};
		case ReportsActionsTypes.SET_IDS_SCHEDULE_TYPES:
			return {
				...state,
				IDsScheduleTypes: action.payload.IDsScheduleTypes,
			};
		case ReportsActionsTypes.CHANGE_EMAILS:
			return {
				...state,
				emails: action.payload.emails,
			};
		case ReportsActionsTypes.CHANGE_COPY_EMAILS:
			return {
				...state,
				copyEmails: action.payload.copyEmails,
			};
		case ReportsActionsTypes.TOGGLE_SENDING_REPORT_AFTER_SHIFT_CLOSING:
			return {
				...state,
				sendingReportAfterShiftClosing: !state.sendingReportAfterShiftClosing,
			};
		case ReportsActionsTypes.SET_DATA_FOR_SUBMIT:
			return {
				...state,
				dataForSubmit: action.payload.dataForSubmit,
			};
		case ReportsActionsTypes.CHANGE_TYPE_OF_MODAL_WINDOW:
			return {
				...state,
				typeOfModalWindow: action.payload.typeOfModalWindow,
			};
		default:
			return state;
	}
};
